export const formatTime = (date: Date) => {
  // Note: Due to QQ browser limitation
  // "toLocaleTimeString" cannot be used to format the time
  const hours = `0${date.getHours()}`.substr(-2);
  const minutes = `0${date.getMinutes()}`.substr(-2);

  return `${hours}:${minutes}`;
};
